import React, { useEffect, useState } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import coursesData from "../../data/CourseData";
import InscriptionModal from "../modals/InscriptionModal";
import WhatsAppButton from "../header/WhatsAppButton";
import Accordion from "../pages/Accordion";
import flechas from "../../assets/img/flechas.webp";
import logogarantia from "../../assets/img/sello_garantia.webp";
import studentsSatisfaction from "../../assets/img/studentsSatisfaction.webp";
import students from "../../assets/img/students.webp";
import { getLocation } from "../utils/GetLocation";
import { trackMetaEvent } from '../utils/MetaPixel';
import { CountdownTimer } from '../utils/CountdownTimer';
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import testimonio1 from "../../assets/img/testimonioIntrodProg1.webp";
import testimonio2 from "../../assets/img/testimonioIntrodProg2.webp";
import testimonio3 from "../../assets/img/testimonioIntrodProg3.webp";
import testimonio4 from "../../assets/img/testimonioIntrodProg4.webp";
import testimonio5 from "../../assets/img/testimonioIntrodProg5.webp";
import testimonio6 from "../../assets/img/testimonioIntrodProg6.webp";
import imgHeader from "../../assets/img/page-header.webp";
import imgWhatsApp from "../../assets/img/whatsApp.svg";
import PresalePrices from "../utils/PresalePrices";
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const CourseDetail = () => {
  const { id } = useParams();
  // Buscar el curso por ID en la lista de cursos
  const course = coursesData.find(course => course.id === id);

  const phoneNumber = "573028688273";
  const message = encodeURIComponent(
    `Quiero inscribirme en el curso de "${course.titleMain}" con la promoción de la página web pero aún tengo dudas y quisiera resolverlas`
  );
  const whatsappUrl = `https://api.whatsapp.com/send?phone=${phoneNumber}&text=${message}`;

  const [showModal, setShowModal] = useState(false); // Estado del modal
  const [price, setPrice] = useState({ oldPrice: "No Disponible", newPrice: "No Disponible", priceInscription: "No Disponible" });
  const [presalePrices, setPresalePrices] = useState({});
  const [country, setCountry] = useState('');

  const handleShowModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);

  let countryValues = 'us';

  //Mover el scroll al inicio cuando se carga la página
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    getLocation().then(({ countryCode }) => {
      const resolvedCountry = countryCode || 'us';
      setCountry(resolvedCountry);
      countryValues = course.values[countryCode] || course.values["us"]; // Si el país no está definido, usa USD
      setPrice({ oldPrice: countryValues.oldPrice.toLocaleString("de-DE"), newPrice: countryValues.newPrice.toLocaleString("de-DE"), priceInscription: ((countryValues.newPrice) * 0.6).toLocaleString("de-DE"), currency: countryValues.currency, priceFormat: countryValues.newPrice });
      setPresalePrices(countryValues?.presale)
    });
  }, [course.values]);

  useEffect(() => {
    if (course) {
      // 🔹 Enviar evento de "ViewContent" cuando alguien entra a la página del curso
      trackMetaEvent('ViewContent', {
        content_name: course.title,
        content_category: 'Curso Online',
        content_ids: [course.id]
      });
    }
  }, [course]);

  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000
  };

  const handleScrollAndTrack = () => {
    // Navega al div con id="pricing"
    document.getElementById('pricing')?.scrollIntoView({ behavior: 'smooth' });

    // Ejecuta tu evento de tracking
    trackMetaEvent('Lead', { content_name: course.title });
  };

  const navigate = useNavigate();

  // Si no se encuentra el curso, mostrar mensaje de "En desarrollo"
  if (!course.active) {
    return (
      <>
        {/* Header Section */}
        <div className="w-100 overflow-hidden mb-5 position-relative" style={{ minHeight: '300px' }}>
          <img
            src={imgHeader}
            alt="Encabezado de página curso online"
            className="position-absolute top-0 start-0 w-100 h-100 object-fit-cover"
            style={{ zIndex: 0 }}
            loading="eager"
            decoding="async"
            fetchpriority="high"
          />

          <div className="position-absolute top-0 start-0 w-100 h-100" style={{ background: 'rgba(0, 0, 0, 0.5)', zIndex: 1 }}></div>

          <div className="container position-relative" style={{ zIndex: 2 }}>
            <div className="d-flex flex-column justify-content-center h-100" style={{ minHeight: '300px' }}>
              <h3 className="display-4 text-white text-uppercase">Detalles del curso</h3>
              <div className="d-inline-flex text-white">
                <p className="m-0 text-uppercase">
                  <Link to="/">Inicio</Link>
                </p>
                <i className="fa fa-angle-double-right pt-1 px-3"></i>
                <p className="m-0 text-uppercase">Detalles del curso</p>
              </div>
            </div>
          </div>
        </div>
        <div className="container py-5 text-center">
          <h2 style={{ backgroundColor: "red", color: "white" }}>El curso aún no está disponible, pero muy pronto abriremos inscripciones. 🎉</h2>
          <h3 className="text-center mt-4">Atento al lanzamiento los próximos días para obtener el precio de PREVENTA.</h3>
        </div>
        <div className="text-center">
          <button onClick={() => navigate("/")} className="px-4 py-2 btn-primary">
            IR A LA PÁGINA PRINCIPAL
          </button>
        </div>
      </>
    );
  }

  return (

    <div style={{ fontFamily: 'Poppins, sans-serif', backgroundColor: '#0f172a', color: '#fff' }}>
      <div className="top-banner">
        <div className="scrolling-text">
          {course.hookMain}
        </div>
      </div>
      {/* HERO */}
      <section className="content-wrapper" style={{ display: 'flex', flexWrap: 'wrap', padding: '3rem 1rem', background: '#1e293b', alignItems: 'center', justifyContent: 'center' }}>
        <div style={{ flex: '1 1 400px', padding: '1rem', maxWidth: '500px' }}>
          <h1 style={{ fontSize: '2.2rem', fontWeight: 'bold', color: 'white', textAlign: 'center' }}>
            {course.title.map((part, index) => (
              <span key={index} style={part.style}>
                {part.text}{" "}
              </span>
            ))}
            <hr></hr>
            <p style={{ fontStyle: 'italic', fontWeight: 300, color: 'white', fontSize: '1.3rem', textAlign: 'justify' }}>{course.subtitle}</p>
          </h1>
          <button onClick={handleScrollAndTrack}
            style={{ background: '#2563eb', color: '#fff', padding: '1rem 2rem', marginTop: '1.5rem', borderRadius: '8px', border: 'none', fontSize: '1rem' }}>
            Quiero asegurar mi cupo ahora
          </button>
          <hr></hr>
          <h5 className="text" style={{ color: "white" }}>Fecha de inicio: {course.startDate}</h5>
        </div>
        <div style={{ flex: '1 1 300px', padding: '1rem', textAlign: 'center' }}>
          <img src={course.imageIndex} alt={course.title} style={{ borderRadius: '10px', width: '100%', maxWidth: '400px' }} />
        </div>

      </section>

      {/* BENEFICIOS */}
      <section className="content-wrapper" style={{ background: '#facc15', color: '#000', padding: '3rem 1rem' }}>
        <h2 style={{ fontSize: '1.6rem', fontWeight: 'bold', textAlign: 'center' }}>🚀 BENEFICIOS QUE OBTENDRÁS</h2>
        <ul>
          {course.benefits.map((item, index) => (
            <div key={index} className="text-justify">
              <h5> {item} </h5>
            </div>
          ))}
        </ul>
      </section>

      {/* PLAN DE ESTUDIO */}
      <section className="content-wrapper" style={{ background: '#111827', padding: '3rem 1rem' }}>
        <h2 style={{ textAlign: 'center', fontSize: '1.6rem', fontWeight: 'bold', color: 'white' }}>📘 PLAN DE ESTUDIO</h2>
        <div style={{ maxWidth: '900px', margin: '2rem auto', display: 'flex', flexWrap: 'wrap', justifyContent: 'space-around' }}>
          <Accordion course={course} />
        </div>
      </section>

      {/* INSTRUCTOR */}
      <section className="content-wrapper" style={{ background: '#facc15', color: '#000', padding: '3rem 1rem' }}>
        <h2 style={{ textAlign: 'center', fontSize: '1.6rem', fontWeight: 'bold' }}>👨‍🏫NUESTRO INSTRUCTOR</h2>
        <div style={{ maxWidth: '900px', margin: '2rem auto', display: 'flex', flexWrap: 'wrap', alignItems: 'center', justifyContent: 'center' }}>
          <img src={course.instructor.image} alt={course.instructor.name} style={{ borderRadius: '100%', width: '150px', height: '150px', marginRight: '1rem', alignContent: 'center' }} />
          <div style={{ flex: '1 1 300px' }}>
            <h3 style={{ fontWeight: 'bold', textAlign: 'center' }}>{course.instructor.name}</h3>
            <h6 style={{ fontWeight: 'bold', textAlign: 'center' }}>{course.instructor.profession}</h6>
            <p>{course.instructor.bio}</p>
          </div>
        </div>
        <div className="text-center">
          <button className="px-4 py-2 buy-btn" onClick={handleScrollAndTrack}>🔥 Inscribirme Ahora</button>
        </div>
      </section>

      <div id="pricing" className="img-bonus">
        <img src={course.imgBonus} alt="Beneficios Curso Online" />
      </div>
      <section className="content-wrapper" style={{ background: '#facc15', color: '#000', padding: '3rem 1rem', textAlign: 'center' }}>
        <h2 className="gradient-text text-center">{course.SenseUrgency}</h2>

        {/* PRECIOS Y PROMOCIONES */}
   
        <h3 className="text-center mb-5" style={{ color: "red" }}>¡SI ESTAS CON VPN DESCONECTATE PARA VER PRECIOS DE TU PAIS!</h3>
        {course?.presale && !(countryValues?.presale) && (<div className="p-8">
          <PresalePrices values={presalePrices} currency={price.currency} />
        </div>)}

        <div className="dynamic-offer">
          <div className="discount-label">🔥 PAGO ÚNICO ACCESO DE POR VIDA 🔥</div>

          <h2 className="offer-title">¡No dejes pasar esta oportunidad!</h2>

          <div className="prices">
            <span className="old-price">
              Antes:
              <span className="crossed-price"> {price.oldPrice} {price.currency}</span>
            </span>
            <span className="new-price">AHORA: {price.newPrice} {price.currency}</span>
          </div>

          <button className="cta-button" onClick={() => {
            handleShowModal();
            trackMetaEvent('InitiateCheckout', { content_name: course.title, content_ids: [course.id], currency: price.currency, value: price.newPrice })
          }
          }>💥 INSCRIBIRME CON DESCUENTO</button>
          <p className="payment-info">
            ESTÁS AHORRANDO: {
              (() => {
                const cleanOld = parseFloat(price.oldPrice.replace(/\./g, "").replace(/,/g, "."));
                const cleanNew = parseFloat(price.newPrice.replace(/\./g, "").replace(/,/g, "."));
                const ahorro = cleanOld - cleanNew;

                return ahorro >= 1000
                  ? Math.round(ahorro).toLocaleString()
                  : Math.round(ahorro).toString();
              })()
            } {price.currency}
          </p>
          <h5 style={{ color: 'white' }}>Paga AHORA con:</h5>
        </div>
        <br></br>
        <h1 className="animated-text">¡ESTAS A UN PASO DE CAMBIAR TU FUTURO CON ESTE CURSO!</h1>
        <br></br>
      </section>

      {/* TESTIMONIOS */}
      {course.id === "1" && (
        <section className="content-wrapper" style={{ backgroundColor: '#0f172a', padding: '3rem 1rem', textAlign: 'center' }}>
          <h2 style={{ fontSize: '1.6rem', fontWeight: 'bold', marginBottom: '2rem', color: 'white' }}>💬 LO QUE DICEN NUESTROS ESTUDIANTES</h2>
          <div style={{ maxWidth: '600px', margin: '0 auto' }}>
            <Slider {...sliderSettings}>
              <div>
                <img src={testimonio1} alt="Estudiante 1" style={{ borderRadius: '10px', width: '100%' }} />
              </div>
              <div>
                <img src={testimonio2} alt="Estudiante 2" style={{ borderRadius: '10px', width: '100%' }} />
              </div>
              <div>
                <img src={testimonio3} alt="Estudiante 3" style={{ borderRadius: '10px', width: '100%' }} />
              </div>
              <div>
                <img src={testimonio4} alt="Estudiante 4" style={{ borderRadius: '10px', width: '100%' }} />
              </div>
              <div>
                <img src={testimonio5} alt="Estudiante 5" style={{ borderRadius: '10px', width: '100%' }} />
              </div>
              <div>
                <img src={testimonio6} alt="Estudiante 5" style={{ borderRadius: '10px', width: '100%' }} />
              </div>
            </Slider>
          </div>
        </section>
      )}

      {/* TIMER */}
      {course?.emergencyStopwatch && (
        <section className="content-wrapper" style={{ backgroundColor: '#1e293b', textAlign: 'center' }}>
          <CountdownTimer />
        </section>)}

      {/* GARANTÍA */}
      <section className="content-wrapper" style={{ background: '#0f172a', padding: '2rem 1rem', textAlign: 'center' }}>
        <h2 style={{ fontSize: '1.6rem', fontWeight: 'bold', color: 'white' }}>🎯 GARANTÍA DE EXCELENCIA</h2>
        <div className="garantia-container">
          <div className="garantia-text">
            <h4 style={{ color: 'white', fontSize: '1.125rem', marginTop: '1rem', textAlign: 'justify' }}>
              Con nuestro curso y el Sello de Excelencia de 5 Días, no solo aprenderás, sino con total confianza.
            </h4>
            <h6 style={{ color: 'white', fontSize: '1.125rem', marginTop: '1rem', textAlign: 'justify' }}>
              💡 Si en los primeros 5 días te arrepientes de tu compra, te devolvemos el 80% de tu inversión. Así de fácil.
            </h6>
            <h6 style={{ color: 'white', fontSize: '1.125rem', marginTop: '1rem', textAlign: 'justify' }}>
              🔐 Aprende sin miedo. Invierte sin riesgo.
            </h6>
            <h6 style={{ color: 'white', fontSize: '1.125rem', marginTop: '1rem', textAlign: 'justify' }}>
              🔥 Cientos de alumnos ya comenzaron… ¿y tú?
            </h6>
          </div>
          <div className="garantia-img">
            <img
              src={logogarantia}
              alt="Sello 7 días de garantía"
              style={{ width: '100%', maxWidth: '300px', height: 'auto' }}
            />
          </div>
        </div>
      </section>


      {/* VALIDACIONES SOCIALES */}
      <section className="content-wrapper" style={{ background: '#facc15', color: '#000', padding: '3rem 1rem', textAlign: 'center' }}>
        <h2 style={{ fontSize: '1.6rem', fontWeight: 'bold' }}>🎓 ¿POR QUÉ CONFIAR EN NOSOTROS?</h2>
        <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-around', marginTop: '2rem' }}>
          <div style={{ flex: '1 1 250px', margin: '1rem' }}>
            <img src={students} alt="Estudiantes" style={{ borderRadius: '10px', width: '65%' }} />
            <p style={{ marginTop: '1rem' }}><strong>{course.certifiedStudents}</strong></p>
          </div>
          <div style={{ flex: '1 1 250px', margin: '1rem' }}>
            <img src={studentsSatisfaction} alt="Satisfacción" style={{ borderRadius: '10px', width: '65%' }} />
            <p style={{ marginTop: '1rem' }}><strong>97% de satisfacción estudiantil</strong></p>
          </div>
          <div style={{ flex: '1 1 250px', margin: '1rem' }}>
            <img src={logogarantia} alt="Garantía" style={{ borderRadius: '10px', width: '43%' }} />
            <p style={{ marginTop: '1rem' }}><strong>Garantía de satisfacción</strong></p>
          </div>
        </div>
      </section>

      {/* OTRA INFORMACIÓN RELEVANTE DEL CURSO Y DETALLE DEL COSTO */}
      <section className="content-wrapper" style={{ backgroundColor: '#0f172a', padding: '3rem 1rem', textAlign: 'center' }}>
        <h2 style={{ fontSize: '1.6rem', fontWeight: 'bold', marginBottom: '2rem', color: 'white' }}>⏳ DURACIÓN</h2>
        <div style={{ maxWidth: '600px', margin: '0 auto' }}>
          {course.duration}
        </div>
        <br></br>
        <h2 style={{ fontSize: '1.6rem', fontWeight: 'bold', marginBottom: '2rem', color: 'white' }}>💻 MODALIDAD</h2>
        <div style={{ maxWidth: '600px', margin: '0 auto' }}>
          {course.mode}
        </div>
      </section>
      <section className="content-wrapper" style={{ backgroundColor: '#facc15', padding: '1rem 1rem', textAlign: 'center' }}>
        <h2 className="mt-4">COSTO</h2>
        <h5 className="mt-3 text-black font-weight-bold">Este curso normalmente tiene un valor de {price.oldPrice} {price.currency} pero en precio de PREVENTA te podrás llevar: </h5>
        <ul>
          {course.includedCourse.map((item, index) => (
            <div key={index} className="text-justify">
              <h5>✔️ {item} </h5>
            </div>
          ))}
        </ul>
        <h1 className="mt-4 text-black font-weight-bold text-center" style={{ backgroundColor: "red", color: "white" }}>POR UN VALOR ÚNICO DE {price.newPrice} {price.currency}</h1>
        <h5 className="mt-4 text-black font-weight-bold text-center">SI QUIERES ASEGURAR TU CUPO YA Y NO TIENES EL DINERO COMPLETO, PUEDES REALIZAR LA INSCRIPCIÓN CON SÓLO EL 60% DE ESTE VALOR.</h5>
        <h4 className="mt-4 text-black font-weight-bold text-center">ES DECIR SÓLO PAGARÁS HOY {price.priceInscription} {price.currency} POR TU INSCRIPCIÓN.</h4>
        <hr style={{ border: "3px solid red", margin: "20px 0" }} />
        {course?.ebook && (<Link to={`https://api.whatsapp.com/send?phone=${phoneNumber}&text=Hola. Me gusta el curso pero por ahora sólo quiero comprar el Ebook de Programación para Todos;`}><div className="img-ebook"><img src={course.ebook} alt={course.title} /></div></Link>)}
        <div className="bg-white py-12 px-6 md:px-24 flex flex-col md:flex-row items-center justify-between">
        </div>
        <div className="text-center">
          <h4 className="text-center mt-4">
            Haz clic en el botón abajo si no quieres esperar más..
          </h4>
          <img src={flechas} alt="flechas" width="25%" />
        </div>
        <div className="text-center">
          <button className="px-4 py-2 buy-btn" onClick={() => {
            handleShowModal();
            trackMetaEvent('InitiateCheckout', { content_name: course.title, content_ids: [course.id], currency: price.currency, value: price.newPrice })
          }
          }>¡Inscribirme Ahora con Descuento!</button>
        </div>
        <br></br>
        <h6 className="text-center">
          <p>Pago 100% seguro en Dissemp Academy Courses desde cualquier país</p>
        </h6>
      </section>
      <section className="content-wrapper" style={{ backgroundColor: '#0f172a', padding: '3rem 1rem', textAlign: 'center' }}>
        <div className="center-flex text-center">
          <h2 className="mt-4" style={{ color: 'white' }}>¿Aún tienes dudas? ¡Contáctanos al WhatsApp!</h2>
          <a href={whatsappUrl} target="_blank" rel="noopener noreferrer" className="whatsapp-button" onClick={() => trackMetaEvent('Lead', { content_name: course.title })}>
            <img
              src={imgWhatsApp}
              alt="WhatsApp Icon"
              className="whatsapp-icon"
            />
            Click en este botón
          </a>
        </div>
        <p className="text-slate-500 text-white mt-4"><h1>Transformando futuros a través de la educación</h1></p>
      </section>
      
      <WhatsAppButton course={course}/>
      {/* Modal de Inscripción */}
      <InscriptionModal show={showModal} handleClose={handleCloseModal} course={course} newPrice={price.priceFormat} currency={price.currency} country={country} />
    </div>


  );
};

export default CourseDetail;
